import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { forkJoin, reduce, Subject, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'app-profile-information',
    templateUrl: './profile-information.component.html',
    styleUrls: ['./profile-information.component.css'],
    standalone: false
})
export class ProfileInformationComponent {
  @Input() profileData: any;
  @Input() profileImg: any;
  @ViewChild('editForm') editForm!: NgForm;
  isEditMode = false;
  files: any;
  @Input() profGen:any;
  originalProfileData: any = {};
  today: any;
  editableProfileData: any = {};
  countryCode: any = '';
  countryMap: any = {
    AE: { mobile: '+971', flag: '🇦🇪' },
    AR: { mobile: '+54', flag: '🇦🇷' },
    AU: { mobile: '+61', flag: '🇦🇺' },
    BE: { mobile: '+32', flag: '🇧🇪' },
    BD: { mobile: '+880', flag: '🇧🇩' },
    BR: { mobile: '+55', flag: '🇧🇷' },
    CA: { mobile: '+1', flag: '🇨🇦' },
    CH: { mobile: '+41', flag: '🇨🇭' },
    CN: { mobile: '+86', flag: '🇨🇳' },
    DE: { mobile: '+49', flag: '🇩🇪' },
    ES: { mobile: '+34', flag: '🇪🇸' },
    ET: { mobile: '+251', flag: '🇪🇹' },
    FR: { mobile: '+33', flag: '🇫🇷' },
    GB: { mobile: '+44', flag: '🇬🇧' },
    GH: { mobile: '+233', flag: '🇬🇭' },
    ID: { mobile: '+62', flag: '🇮🇩' },
    IN: { mobile: '+91', flag: '🇮🇳' },
    IT: { mobile: '+39', flag: '🇮🇹' },
    JP: { mobile: '+81', flag: '🇯🇵' },
    KE: { mobile: '+254', flag: '🇰🇪' },
    KR: { mobile: '+82', flag: '🇰🇷' },
    LK: { mobile: '+94', flag: '🇱🇰' },
    MX: { mobile: '+52', flag: '🇲🇽' },
    MY: { mobile: '+60', flag: '🇲🇾' },
    NG: { mobile: '+234', flag: '🇳🇬' },
    NL: { mobile: '+31', flag: '🇳🇱' },
    NP: { mobile: '+977', flag: '🇳🇵' },
    NZ: { mobile: '+64', flag: '🇳🇿' },
    PK: { mobile: '+92', flag: '🇵🇰' },
    PH: { mobile: '+63', flag: '🇵🇭' },
    RU: { mobile: '+7', flag: '🇷🇺' },
    SA: { mobile: '+966', flag: '🇸🇦' },
    SG: { mobile: '+65', flag: '🇸🇬' },
    SE: { mobile: '+46', flag: '🇸🇪' },
    TH: { mobile: '+66', flag: '🇹🇭' },
    TZ: { mobile: '+255', flag: '🇹🇿' },
    US: { mobile: '+1', flag: '🇺🇸' },
    VN: { mobile: '+84', flag: '🇻🇳' },
    ZA: { mobile: '+27', flag: '🇿🇦' }
  };
  countryNameToCode: any = {
    UnitedArabEmirates: 'AE',
    Argentina: 'AR',
    Australia: 'AU',
    Belgium: 'BE',
    Bangladesh: 'BD',
    Brazil: 'BR',
    Canada: 'CA',
    Switzerland: 'CH',
    China: 'CN',
    Germany: 'DE',
    Spain: 'ES',
    Ethiopia: 'ET',
    France: 'FR',
    UnitedKingdom: 'GB',
    Ghana: 'GH',
    Indonesia: 'ID',
    India: 'IN',
    Italy: 'IT',
    Japan: 'JP',
    Kenya: 'KE',
    KoreaRepublicof: 'KR',
    SriLanka: 'LK',
    Mexico: 'MX',
    Malaysia: 'MY',
    Nigeria: 'NG',
    Netherlands: 'NL',
    Nepal: 'NP',
    NewZealand: 'NZ',
    Pakistan: 'PK',
    Philippines: 'PH',
    RussianFederation: 'RU',
    SaudiArabia: 'SA',
    Singapore: 'SG',
    Sweden: 'SE',
    Thailand: 'TH',
    TanzaniaUnitedRepublicof: 'TZ',
    UnitedStates: 'US',
    VietNam: 'VN',
    SouthAfrica: 'ZA'
  };
  showCamera = false;
  profileImage: string | null = null;
  videoStream: MediaStream | null = null;
  healthProfileId: string | null = null;


  constructor(
    private dialog: MatDialog, private sanitizer: DomSanitizer, private fb: FormBuilder,
    private auth: AuthService, private dataService: DataService, private router: Router, private toast: ToastrService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    // console.log('Profile log!!!')
    this.profileData = {
      first_name: '',
      last_name: '',
      gender: '',
      dob: '',
      email: '',
      mobile: '',
      password: '',
      countryCode:''
    };
    this.originalProfileData = JSON.parse(JSON.stringify(this.profileData)); // Deep clone
    this.getProfile();
    this.getHealthProfile();

    const now = new Date();
    this.today = now.toISOString().split('T')[0]; // format: YYYY-MM-DD
  }

  getHealthProfile() {
    this.auth.health_profile_details_all().subscribe((res: any) => {
      if (res.data.Profile){
        console.log("get health profile", res.data.Profile.id)
        this.healthProfileId = res.data.Profile.id}
    })
  }

  getProfile() {
    this.auth.get_digicoffer_profile().subscribe((user: any) => {
      this.profileData = {
        first_name: user.data.profile?.first_name || '',
        last_name: user.data.profile?.last_name || '',
        gender: user.data.profile?.gender || '',
        dob: this.convertToDateInputFormat(user.data.profile?.dob) || '',
        email: user.data.profile?.email || '',
        mobile: user.data.profile?.mobile || '',
        password: user.data.profile?.password || '',
        password_last_changed: user.data.profile?.password_last_changed || ''
      };

      // country code added //
      let savedCountry = localStorage.getItem('citizenship');
      if (savedCountry && this.countryNameToCode[savedCountry]) {
        this.countryCode = this.countryNameToCode[savedCountry]; // e.g."IN"
      } else {
        this.countryCode = 'US'; // fallback
      }
      this.profileData.countryCode = this.countryMap[this.countryCode]?.mobile || '+1'; // set dial code in profileData
      // country code added //

    // Convert "MM/DD/YYYY" to "YYYY-MM-DD"
    if (this.profileData?.dob) {
      const parts = this.profileData.dob.split('/');
      if (parts.length === 3) {
        const [month, day, year] = parts;
        this.profileData.dob = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
    }
    console.log('get profData', this.profileData);

    // Save a copy of the original data for comparison
    // this.originalProfileData = { ...this.profileData };

    // Save a deep copy of the original data for comparison
    this.originalProfileData = JSON.parse(JSON.stringify(this.profileData));

    });

    // this.auth.get_digicoffer_profile().subscribe((user: any) => {
    //   this.profileData = user.data;
    // })

    // this.auth.profile_details().subscribe((res:any) =>{
    //   //this.profGen = res[0];
    // })

    this.auth.get_image().subscribe((img: any) => {
      this.profileImg = img.data.imageUrl;
    })
  }

  convertToDateInputFormat(dob: string): string {
    if (!dob) return '';
    const parts = dob.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dob; // Return as is if the format doesn't match
  }

  toggleEdit() {
    this.isEditMode = !this.isEditMode;
    // if (this.isEditMode) {
    //   // Clone current data into editable object to avoid form being pre-filled
    //   this.profileData = { ...this.profileData };
    // }
    if (this.isEditMode) {
      this.editableProfileData = JSON.parse(JSON.stringify(this.profileData));
    }
  }

  changePhoto(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  removePhoto() {
    this.profileImg = null;
  }

  onSubmit() {
    //console.log('update profData', this.profileData);
    // if (!this.profileData) return;

    // const formattedDob = formatDate(this.profileData.dob, 'dd-MM-yyyy', 'en-US');

    // const payload = {
    //   ...this.profileData,
    //   dob: formattedDob
    // };

      let formattedDob = '';
      let formattedDob2;

      // Only format dob if it's a valid date
      if (this.profileData.dob) {
        const dobDate = new Date(this.profileData.dob);
        if (!isNaN(dobDate.getTime())) {
          formattedDob = formatDate(dobDate, 'dd-MM-yyyy', 'en-US');
          formattedDob2 = this.datePipe.transform(dobDate, 'MM-dd-yyyy');
        }
      }

      const payload = {
        ...this.profileData,
        dob: formattedDob // Either formatted date or empty string
      };

      const healthpayload = {
        gender: this.profileData.gender.charAt(0).toUpperCase() + this.profileData.gender.slice(1).toLowerCase(),
        firstName: this.profileData?.first_name || '',
        lastName: this.profileData?.last_name || '',
        dob: formattedDob2,
      };

      // Update if ID exists, else create
      const Id = this.healthProfileId ? Number(this.healthProfileId) : null;

      const requests = [];

    // Always update profile
    requests.push(
      this.auth.updateProfile(payload).pipe(
        catchError(err => {
          // Show error only for this API
          this.toast.error(err.error?.msg || 'Failed to update profile');

          return of(null); // allow forkJoin to continue
        })
      )
    );

    if (Id) {
      // Update profile list
      requests.push(
        this.auth.update_profile_list(Id, healthpayload).pipe(
          catchError(err => {
            // this.toast.error(err.error?.msg || 'Failed to update profile list');
            console.error('update_profile_list failed', err);
            this.getProfile();
            return of(null);
          })
        )
      );
      this.getProfile();
    } else {
      // Create profile list
      requests.push(
        this.auth.create_profile_list(healthpayload).pipe(
          catchError(err => {
            // this.toast.error(err.error?.msg || 'Failed to create profile list');
            console.error('create_profile_list failed', err);
            return of(null);
          })
        )
      );
    }

    // Run all requests in parallel
    forkJoin(requests).subscribe({
      next: res => {
        console.log('All requests finished:');
        this.toast.success('Profile updated successfully');
        this.toggleEdit();
      }
    });


    // this.auth.updateProfile(payload).subscribe(
    //   (res: any) => {
    //     if (res.error === false) {
    //       this.toast.success(res.msg);
    //       this.toggleEdit(); // switch to view mode
    //     } else {
    //       this.toast.error(res.msg || 'Something went wrong');
    //     }
    //   },
    //   (error: HttpErrorResponse) => {
    //     this.toast.error(error.error.msg ||  error.error?.errors?.[0]?.msg || 'Failed to update profile');
    //   }
    // );
    this.getProfile(); // Refresh data
  }

  hasProfileChanged(): boolean {
    // console.log('profileData',this.profileData)
    // console.log('org',this.originalProfileData)
    //return JSON.stringify(this.profileData) !== JSON.stringify(this.originalProfileData);
    return JSON.stringify(this.editableProfileData) !== JSON.stringify(this.originalProfileData);
  }

  onCancel(): void {
    if (this.hasProfileChanged()) {
      console.log('if')
      this.onConfirm(); // Show confirmation dialog
    } 
    else {
       console.log('else')
      this.toggleEdit(); // No changes, directly toggle
    }
  }

  onConfirm(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      height: '200px',
      disableClose: true,
      data: { message: 'Are you sure you want to continue ?' },
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        // this.profileData = JSON.parse(JSON.stringify(this.originalProfileData)); // reset changes
        // this.toggleEdit(); // Proceed if the user confirms
        this.isEditMode = !this.isEditMode;
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });

      }
    });
  }

  openChangePasswordDialog() {
    // this.dialog.open(ChangePasswordDialogComponent, {
    //   width: '550px',
    //   panelClass: 'custom-dialog-container',
    //   disableClose: true
    // });
        
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '550px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getProfile();
    });
  }

  onFileChanged(event: any) {
    const file = event.target.files[0]; // Use a local variable for clarity
    if (!file) {
      return; // Exit if no file is selected
    }

    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      this.toast.error('Must be an image (JPEG, PNG, or JPG)');
      return;
    }

    // Validate file size (2 MB)
    if (file.size > 2 * 1024 * 1024) {
      this.toast.error('File size exceeds 2 MB');
      return;
    }

    this.files = file; // Assign the valid file
    this.onUpload();
  }

  onUpload() {
    //console.log(this.files)
    const formData = new FormData();
    formData.append("file", this.files);
    //console.log(formData)
    this.auth.upload_image(formData).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success('Profile updated successfully')

        this.auth.get_image().subscribe((res: any) => {
          if (res) {
            this.profileImg = res.data.imageUrl;
            //console.log('Profile Image URL set in DataService:', this.profileImg);
            this.dataService.setProfilePic(this.profileImg); // passing to dashboard topbar
          }
        })         
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
    })

  }

  onDelete() {
    //console.log(this.files)
    const formData = new FormData();
    formData.append("file", this.files);
    //console.log(formData)
    this.auth.delete_image(formData).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success('Profile updated successfully')

        this.auth.get_image().subscribe((res: any) => {
          if (res) {
            this.profileImg = res.data.imageUrl;          
            //console.log('Del Profile Image URL set in DataService:', this.profileImg);
            this.dataService.setProfilePic(this.profileImg); // passing to dashboard topbar
          }
        })
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
    })
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }
    
  //prevent space at 1st position
  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;

    // If space is pressed at position 0, prevent it
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault();
    }
  }

  preventInvalidStart(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    // If it's the first character
    if (input.selectionStart === 0) {
      const char = event.key;

      // Block spaces, numbers, and special characters at the beginning
      if (!/^[a-zA-Z]$/.test(char) && char.length === 1) {
        event.preventDefault();
      }
    }
  }

  validateFirstName() {
    if (this.profileData.first_name) {
      // Remove leading spaces/numbers/special characters from pasted text
      this.profileData.first_name = this.profileData.first_name.replace(/^[^a-zA-Z]+/, '');
    }
  }

  validateLastName() {
    if (this.profileData.last_name) {
      this.profileData.last_name = this.profileData.last_name.replace(/^[^a-zA-Z]+/, '');
    }// first_name & last_name
  }



openCamera() {
  this.showCamera = true;
  navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
    this.videoStream = stream;
    const video: any = document.querySelector("video");
    if (video) {
      video.srcObject = stream;
    }
  });
}

  capturePhoto(video: HTMLVideoElement) {
    const canvas: any = document.querySelector("canvas");
    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    this.profileImage = canvas.toDataURL("image/png"); // preview

    // Convert to file for upload
    canvas.toBlob((blob: any) => {
      if (blob) {
        const file = new File([blob], "photo.png", { type: "image/png" });
        this.uploadCapturedImage(file);
      }
    }, "image/png");

    this.closeCamera();
  }

  closeCamera() {
    this.showCamera = false;
    if (this.videoStream) {
      this.videoStream.getTracks().forEach((track) => track.stop());
    }
  }

  uploadCapturedImage(file: File) {
    const formData = new FormData();
    formData.append("file", file);

    this.auth.upload_image(formData).subscribe((res: any) => {
      if (res.error == false) {
        this.toast.success('Profile updated successfully')

        this.auth.get_image().subscribe((res: any) => {
          if (res) {
            this.profileImg = res.data.imageUrl;
          }
        })
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
    })
  }

}
